export default __webpack_public_path__ + "static/media/sanitas.7f06d5d0.png";